// extracted by mini-css-extract-plugin
export default {"select":"c_fJd","optionTrigger":"sdjw3","option":"JGXBl","optionIcon":"CNeUj","optionText":"KMzHA"};